import React from 'react';
import { ANIMATION_SEC } from '../globalStyles';

export const NewArrowIcon: React.FC<{ direction: 'up' | 'down' | 'left' | 'right' }> = ({ direction }) => {
    let deg: number = 0;

    switch (direction) {
        case 'left':
            deg = -90;
            break;
        case 'right':
            deg = 90;
            break;
        case 'down':
            deg = 180;
            break;
        case 'up':
            deg = 0;
            break;
        default:
            break;
    }
    return (
        <div
            style={{
                transition: `all 0.1s`,
                transform: `rotate(${deg}deg)`,
            }}
        >
            <svg width="1rem" height="1rem" viewBox="7 9 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.3756 14.5016L12.3772 9.50165L7.37891 14.5016" stroke="#000000"/>
            </svg>
        </div>
    );
};
